module.exports = __webpack_public_path__ + "static/media/sandoz.4c934965.jpg";